import React, { useState } from 'react';
import { Row, Col, Container, Image, Tab, Nav, Button, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import ProductsList from './Products/ProductsList';
import ShowList from './Shows/ShowList';
import PromoList from './Promos/PromoList';
import { PRODUCTOS_TAB, SHOW_TAB, PANDAPARTY_TAB } from '../../../images/images';
import { useStateValue } from '../../utilities/StateProvider';

export default function StepThree(props) {

    const [{ isInterior }, dispatch] = useStateValue();
    const [ activeTab, setActiveTab ] = useState('productos');

    const handleChangeInterior = (value) => {
        dispatch({
            type: 'setInterior',
            isInterior: value
        });
    }

    const back = () => {
        switch (activeTab) {
            case 'shows':
                setActiveTab('productos');
                break;
            case 'pandaparty':
                setActiveTab('shows');
                break;
            default:
                break;
        }
    }

    const next = () => {
        switch (activeTab) {
            case 'productos':
                setActiveTab('shows');
                break;
            case 'shows':
                setActiveTab('pandaparty');
                break;
            case 'pandaparty':
                props.next();
                break;
            default:
                break;
        }
    }

    return (
        <Container className="shop-container">
            <Row>
                <Col className="step-header">
                    <div className="title">Elige tu servicio</div>
                </Col>
            </Row>
            <Row>
                <ButtonToolbar className="price-toggle">
                    <ToggleButtonGroup name="price-toggle" value={isInterior} onChange={handleChangeInterior}>
                        <ToggleButton value={false} className="toggle-button">Caracas</ToggleButton>
                        <div className="price-toggle-divisor"/>
                        <ToggleButton value={true} className="toggle-button">Otros Estados</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
            </Row>
            <Tab.Container activeKey={activeTab} defaultActiveKey={"productos"} onSelect={k => setActiveTab(k)}>
                <Row>
                    <Nav className="product-tabs justify-content-center" activeKey={activeTab} defaultActiveKey="productos">
                        <Col xs={6} sm={4} md={3}>
                            <Nav.Link eventKey="productos">
                                <Image src={PRODUCTOS_TAB} roundedCircle fluid/>
                                <div className="title">Productos</div>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                            <Nav.Link eventKey="shows">
                                <Image src={SHOW_TAB} roundedCircle fluid/>
                                <div className="title">Shows</div>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} sm={4} md={3}>
                            <Nav.Link eventKey="pandaparty">
                                <Image src={PANDAPARTY_TAB} roundedCircle fluid/>
                                <div className="title">Panda Party</div>
                            </Nav.Link>
                        </Col>
                    </Nav>
                </Row>
                <Row>
                    <Col>
                        <Tab.Content>
                            <Tab.Pane eventKey="productos">
                                <ProductsList type="products"/>
                            </Tab.Pane>
                            <Tab.Pane eventKey="shows">
                                <ShowList />
                            </Tab.Pane>
                            <Tab.Pane eventKey="pandaparty">
                                <PromoList />
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
            {activeTab !== 'productos' ? <Button className="shop-button" onClick={back}>Atrás</Button> : null}
            <Button className="shop-button" onClick={next}>SIGUIENTE</Button>
        </Container>
    )
}
